<template>
  <div class="crumbs">
    <span class="direct-tip">当前位置：</span>
    <a class="direct-dir" :href="href">{{ trail }}</a>
    <span class="direct-sub-dir">{{ subTrail }}</span>
  </div>
</template>

<script>
export default {
  props: {
    trail: String,
    subTrail: String,
    href: String
  }
}
</script>

<style lang="scss">
@import '../../../common/scss/color.scss';

.crumbs {
  padding-left: 6px;
  border-left: 3px solid #bbb;
  margin: 14px 10px;
  background-color: #f5f5f5;
  height: 37px;
  line-height: 37px;
  font-size: 14px;
  .direct-tip {
    color: #333;
  }
  .direct-dir {
    color: $mainColor;
    &:hover {
      text-decoration: underline;
    }
  }
  .direct-sub-dir {
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/crumbs/crumbs.vue